import { FormikProps } from "formik";
import { FirmaDto } from "../../../../../../interfaces/schema";
import { FormikTextArea } from "../../../../../formcontrols/TextArea";
import { FirmaFields } from "./StamoplysningerTop";

const FirmaStamBemaerkninger = ({
  firma,
  editMode,
  formik,
}: {
  firma: FirmaDto;
  editMode: boolean;
  formik: FormikProps<FirmaFields>;
}) => {
  return (
    <div className="c-card">
      <div className="flex-100">
        {editMode && (
          <FormikTextArea
            config={{
              component: "textarea",
              id: "bemaerkninger",
              initialValue: "",
              label: "Bemærkninger",
              placeholder: "Ingen bemærkninger",
            }}
            formik={formik}
          />
        )}
        {!editMode && (
          <>
            <h5 className="form-label">Bemærkninger</h5>
            <div
              className="form-control--value is-editable"
              style={{ whiteSpace: "pre-wrap", minHeight: "4.4rem" }}
            >
              {!firma.bemaerkninger && <span className="text-muted">-</span>}
              {firma.bemaerkninger}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FirmaStamBemaerkninger;
